import * as React from "react";
import axios from "axios";
import { go } from "./ui";

export function Navigator() {
  const [headline, setHeadline] = React.useState("TestNet 3.0.0");
  const route = new URLSearchParams(window.location.search).get("route") || "HOME";

  React.useEffect(() => {
    axios.get("/gui-settings").then((r) => setHeadline(r.data.headline || "TestNet 3.0.0"));
  }, []);

  return (
    <header className="site-header">
      <a className="brand" href="index.html" aria-label="Telestai Explorer">
        <img
          className="brand-logo"
          src="/assets/logo-header.png"
          alt="Telestai"
          width={158}
          height={44}
        />
      </a>
      <nav className="nav-links">
        <a href="https://www.telestai.io/" target="_blank" rel="noreferrer">
          Home
        </a>
        <a
          className={route === "HOME" || route === "BLOCKS" ? "active" : ""}
          href="index.html"
        >
          Explorer
        </a>
        <a className={route === "ASSETS" ? "active" : ""} href="index.html?route=ASSETS">
          Assets
        </a>
      </nav>
      <div className="header-right">
        <span className="pill">
          <strong>{headline}</strong>
        </span>
        <a className={"btn btn-primary" + (route === "API" ? " active" : "")} href="index.html?route=API">
          API
        </a>
      </div>
    </header>
  );
}

export function SearchBar() {
  const [query, setQuery] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const search = (event?: React.FormEvent) => {
    event?.preventDefault();
    const value = query.trim();
    if (!value) return;
    setLoading(true);
    axios
      .get("/gettype/" + encodeURIComponent(value))
      .then((response) => {
        const type = response.data.type;
        if (type === "BLOCK") go("BLOCK", { hash: value });
        else if (type === "TRANSACTION") go("TRANSACTION", { id: value });
        else if (type === "ADDRESS") go("ADDRESS", { address: value });
        else if (type === "ASSET") go("ASSET", { name: value });
        else alert("Nothing found for " + value);
      })
      .finally(() => setLoading(false));
  };

  return (
    <form className="search" onSubmit={search}>
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search address, transaction, block, or asset"
      />
      <button className="btn btn-primary" type="submit" disabled={loading}>
        {loading ? "…" : "Search"}
      </button>
    </form>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="wrap">
        <div>© {new Date().getFullYear()} Telestai Project · Core 3.0.0 · Meraki</div>
        <div>
          <a href="https://www.telestai.io/">Website</a>
          {" · "}
          <a href="https://github.com/Telestai-Project/telestai">Core</a>
          {" · "}
          Forked from Rebel Explorer
        </div>
      </div>
    </footer>
  );
}
